import { db } from '@/utils/Firebase'

const COLLECTION = 'aiAlertSettings'

export const DEFAULT_ALERT_SETTINGS = {
    active: true,
    muscleHurtThreshold: 3.5,
    energyThreshold: 2,
    adherenceThreshold: 50,
    windowDays: 7,
    cooldownDays: 3,
}

export function alertSettingsDocId(coachId, studentId) {
    return `${coachId}_${studentId}`
}

export async function loadAlertSettings(coachId, studentId) {
    if (!coachId || !studentId) return { ...DEFAULT_ALERT_SETTINGS }
    const snap = await db.collection(COLLECTION).doc(alertSettingsDocId(coachId, studentId)).get()
    if (!snap.exists) return { ...DEFAULT_ALERT_SETTINGS }
    return { ...DEFAULT_ALERT_SETTINGS, ...snap.data() }
}

export async function saveAlertSettings(coachId, studentId, settings) {
    if (!coachId || !studentId) return
    await db.collection(COLLECTION).doc(alertSettingsDocId(coachId, studentId)).set({
        coachId,
        studentId,
        active: settings.active,
        muscleHurtThreshold: Number(settings.muscleHurtThreshold),
        energyThreshold: Number(settings.energyThreshold),
        adherenceThreshold: Number(settings.adherenceThreshold),
        windowDays: Number(settings.windowDays),
        cooldownDays: Number(settings.cooldownDays),
    }, { merge: true })
}
